import React, { PropTypes } from 'react'

const propTypes = {
  id: PropTypes.string,
  grey: PropTypes.bool
}

const CheckboxOn = props => (
  <svg
    width='24'
    height='24'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...props}>
    <defs>
      <path id={`a-checkbox-on-${props.id}`} d='M0 0h175v40H0z' />
      <mask
        id={`b-checkbox-on-${props.id}`}
        x='0'
        y='0'
        width='175'
        height='40'
        fill='#fff'>
        <use xlinkHref={`#a-checkbox-on-${props.id}`} />
      </mask>
      <path
        d='M2 2.833v18.334c0 .46.373.833.833.833h18.334c.46 0 .833-.373.833-.833V2.833c0-.46-.373-.833-.833-.833H2.833C2.373 2 2 2.373 2 2.833zm7.744 13.09c.326.325.853.325 1.18 0l6.665-6.667c.324-.326.324-.853 0-1.18-.327-.324-.855-.324-1.18 0L10.33 14.16l-2.744-2.75c-.326-.325-.854-.325-1.18 0-.325.326-.325.854 0 1.18l3.334 3.333z'
        id={`c-checkbox-on-${props.id}`}
      />
    </defs>
    <g fill='none' fillRule='evenodd'>
      <path d='M0 0h24v24H0z' />
      <mask id={`d-checkbox-on-${props.id}`} fill='#fff'>
        <use xlinkHref={`#c-checkbox-on-${props.id}`} />
      </mask>
      <path
        d='M0 0h100v40H0z'
        mask={`url(#d-checkbox-on-${props.id})`}
        fill={props.grey ? '#dfdfdf' : '#000'}
      />
    </g>
  </svg>
)

CheckboxOn.propTypes = propTypes

export default CheckboxOn



// WEBPACK FOOTER //
// ./src/svg-icons/CheckboxOn.js